import { Avatar, Stack, Typography } from "@mui/material";
import { APP_NAME } from "../../utils/app-info";
import { APP_BAR_HEIGHT } from "../layout/layoutStyles";

const AppLogo = () => {
  const version = process.env.REACT_APP_VERSION || "1.0.0";

  return (
    <Stack
      direction="row"
      alignItems="center"
      spacing={1.25}
      sx={{
        px: 2,
        height: APP_BAR_HEIGHT,
        minHeight: APP_BAR_HEIGHT,
        boxSizing: "border-box",
        borderBottom: 1,
        borderColor: "divider",
        flexShrink: 0,
      }}
    >
      <Avatar
        src="/images/logo.svg"
        alt="company logo"
        sx={{
          width: 40,
          height: 40,
          bgcolor: "grey.50",
          border: 1,
          borderColor: "divider",
          p: 0.5,
          flexShrink: 0,
        }}
      />
      <Stack minWidth={0} flex={1}>
        <Typography
          variant="subtitle2"
          noWrap
          sx={{ fontWeight: 700, color: "text.primary", lineHeight: 1.3 }}
        >
          {APP_NAME}
        </Typography>
        <Typography variant="caption" color="text.secondary" noWrap>
          v{version}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default AppLogo;
